import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconUsers = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.33301 8.66667C8.33301 7.74619 9.0792 7 9.99967 7C10.9201 7 11.6663 7.74619 11.6663 8.66667C11.6663 9.58714 10.9201 10.3333 9.99967 10.3333C9.0792 10.3333 8.33301 9.58714 8.33301 8.66667ZM9.99967 5C7.97463 5 6.33301 6.64162 6.33301 8.66667C6.33301 10.6917 7.97463 12.3333 9.99967 12.3333C12.0247 12.3333 13.6663 10.6917 13.6663 8.66667C13.6663 6.64162 12.0247 5 9.99967 5ZM7.33366 13C5.30861 13 3.66699 14.6416 3.66699 16.6667V18H5.66699V16.6667C5.66699 15.7462 6.41318 15 7.33366 15H12.667C13.5875 15 14.3337 15.7462 14.3337 16.6667V18H16.3337V16.6667C16.3337 14.6416 14.692 13 12.667 13H7.33366ZM17.583 13.1184C19.2009 13.5362 20.3318 14.9949 20.333 16.6659V18H18.333V16.6671C18.3323 15.9077 17.8183 15.2448 17.083 15.0549L17.583 13.1184ZM14.4189 7.05542C15.1564 7.24424 15.6722 7.90875 15.6722 8.67C15.6722 9.43126 15.1564 10.0958 14.4189 10.2846L14.915 12.2221C16.5374 11.8067 17.6722 10.3448 17.6722 8.67C17.6722 6.99524 16.5374 5.53333 14.915 5.11792L14.4189 7.05542Z"
        />
      </svg>
    );
  }
);
